import { resolveNestedList, useCacheOperations } from "@/composables/cache";
import { useLogger } from "@/composables/logger";
import type { ModelsResolver } from "@/models/resolvers";
import { revisionDefaultFields } from "@/models/resolvers";

const { info: logInfo } = useLogger("SIZINGS_RESOLVER");

export default {
  queries: {
    sizings: {
      author: (parent, args, cache, info) => {
        return parent.journal_author_id
          ? { __typename: "users", id: parent.journal_author_id }
          : null;
      },
      well: (parent, args, cache, info) => {
        return parent.well_id
          ? { __typename: "wells", id: parent.well_id }
          : null;
      },
      parent_sizing: (parent, args, cache, info) => {
        return parent.parent_id
          ? { __typename: "sizings", id: parent.parent_id }
          : null;
      },
      customer: (parent, args, cache, info) => {
        return parent.customer_id
          ? { __typename: "customers", id: parent.customer_id }
          : null;
      },
      scenarios: (parent, args, cache, info) => {
        return resolveNestedList(
          parent.id,
          cache,
          "sizings",
          cache.keyOfField("scenarios", args) || "scenarios",
          "scenarios"
        );
      }
    }
  },
  optimistic: {
    insert_revisions_sizings_revisions: (vars, cache, info) => {
      logInfo("Optimistic", { vars, cache, info });
      const affectedRows = vars.objects.length;

      return {
        __typename: "revisions_sizings_revisions_mutation_response",
        affected_rows: affectedRows,
        returning: vars.objects.map(object => ({
          __typename: "revisions_sizings_revisions",
          id: object.id,
          sizings_view: {
            __typename: "sizings",
            imported_sizing_id: null,
            customer_id: null,
            well_id: null,
            parent_sizing: null,
            author: null,
            well: null,
            customer: null,
            ...object,
            ...revisionDefaultFields(object)
          }
        }))
      };
    }
  },
  updates: {
    insert_revisions_sizings_revisions(result, args, cache, info) {
      logInfo("Mutation Update", { result, args, cache, info });

      args.objects.forEach(object => {
        const isDeleted = Boolean(object.deleted_at);

        const { handleCacheUpdate, deleteAllLinks } = useCacheOperations({
          cache,
          object,
          typename: "sizings"
        });

        if (info.optimistic) {
          handleCacheUpdate([
            {
              args: {
                where: { title: { _eq: "_offline_" } }
              }
            }
          ]);
        }

        handleCacheUpdate([
          {
            args: {
              where: { id: { _eq: object.journal_id } }
            }
          }
        ]);

        if (isDeleted) {
          deleteAllLinks();
        }
      });
    }
  }
} as ModelsResolver;
